import { jsx as _jsx } from "react/jsx-runtime";
import { Label } from '@fluentui/react';
const styles = {
    root: [
        {
            fontSize: 24,
            marginBottom: 20,
            paddingBottom: 0,
        },
    ],
};
export default function TitleField({ id, title, }) {
    return (_jsx(Label, { id: id, styles: styles, children: title }));
}
//# sourceMappingURL=TitleField.js.map